<template>
  <div class="relative">
    <button
      v-if="hasChildren"
      type="button"
      class="relative block w-full pr-8 text-left font-futura-book"
      @click.prevent="expand"
    >
      {{ link.title }}
      <span class="absolute right-0">{{ expanded ? "–" : "+" }}</span>
    </button>
    <a
      v-else
      class="inline-block font-futura-book"
      :href="link.url"
    >{{ link.title }}</a>

    <!-- CHILD LINKS -->
    <expandable
      :expanded="expanded"
      transition-time="0.2s"
    >
      <ul
        v-if="hasChildren"
        :class="childListClasses"
      >
        <li
          v-for="childLink in link.links"
          :key="childLink.title"
        >
          <sidebar-link
            :link="childLink"
            :depth="depth + 1"
          />
        </li>
      </ul>
    </expandable>
  </div>
</template>

<script>
export default {
  name: 'SidebarLink',
  props: {
    link: { type: Object, default: null },
    depth: { type: Number, default: 0 },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    hasChildren() {
      return this.link && this.link.links && this.link.links.length
    },
    childListClasses() {
      return [
        'mt-2 font-futura-book',
        this.depth === 0 ? 'ml-8 text-xl' : 'ml-4 text-base',
      ]
    },
  },
  methods: {
    expand() {
      this.expanded = !this.expanded
    },
  },
}
</script>